import React, { useState } from "react";
import { Checkbox, Form } from "antd";
import ReCAPTCHA from "react-google-recaptcha";

// 6LeddBsqAAAAAEmOkacSKFdca7IhuLzdw5hsz0hM
const Finish = ({ form, formData, setFormData, setcalVal }) => {
  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, terms: e.target.checked });
  };
  const validateConfirmPassword = (_, value) => {
    // console.log(value)
    if (!value || value === form.getFieldValue("terms")) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error("You must agrees to the terms and conditions")
    );
  };
  function onChange(value) {
    console.log("Captcha value:", value);
    setcalVal(value);
  }

  return (
    <section>
      <div className="container">
        <h4>Terms and Conditions</h4>
        <p>Prices subject to change without notice.</p>
        <p>Prices DO NOT include taxes and shipping</p>
        <p>Please call or email with any inquiries for available stock.</p>
        <p>Contact for LB/LC/Natts and Single Cuts and for Big Quantities</p>
        <p>
          Handling Time: Mostly will ship within 1-2 Business Day of receiving
          Payment
        </p>
        <p>Custom and Import Taxes</p>
        <p>
          Please check with local import laws of your country before buying or
          bidding.
        </p>
        <p>
          Applicable Imports duties / customs charges or any TAX charged by the
          buyer's country if any, will have to be borne by the buyer.
        </p>
        <p>We are not responsible of delay due to customs in your country</p>
        <Form.Item
          name="terms"
          valuePropName="checked"
          rules={[
            {
              required: true,
              message: "You must agree to the terms and conditions.",
            },
            { validator: validateConfirmPassword },
          ]}
        >
          <Checkbox checked={formData.terms} onChange={handleCheckboxChange}>
            I agree with the Terms and Conditions.
          </Checkbox>
        </Form.Item>
        <ReCAPTCHA
          sitekey="6Le0lO8nAAAAAJ48LOOEzZYJzNF7x5ZqDXY3mXgV"
          onChange={onChange}
        />
      </div>
    </section>
  );
};

export default Finish;
